
interface TruncatedTextProps {
  text?: string | number | null
  className?: string
  maxWidthClass?: string
  fallback?: string
}

export function TruncatedText({
  text,
  className = '',
  maxWidthClass = 'max-w-[220px]',
  fallback = 'N/A',
}: TruncatedTextProps) {
  const value = text == null || text === '' ? fallback : String(text)

  return (
    <span
      className={`inline-block truncate align-middle ${maxWidthClass} ${className}`}
      title={value}
    >
      {value}
    </span>
  )
}

